import React from "react";

const InformationAndGuidelines = () => {
  return (
    <>
      <div className="inner-page">
        <div className="container">
          <h1 className="policies-title">Information & Guidelines</h1>
          <div className="policies-date">
            Last updated on: 28th November 2024
          </div>
          <div className="admin-content-area">
            <p>
              Following are the guidelines and terms of service of{" "}
              <a href="https://photofind.in" className="a">
                Photofind.in
              </a>
              .
            </p>
            <ol>
              <li>
                Photofind is a web portal created for the use of Photo
                Studios/Wedding Photographers and Corporates/Organisations.
              </li>
              <li>
                Photofind.in and FamilyPhotosAlbum.com (FPA) are two interlinked
                portals under the same management.
              </li>
              <li>
                Corporates/Organizations who register and subscribe with
                Photofind can upload their digital photographs, organize them to
                search and recall whenever required.
              </li>
              <li>
                Photo Studios / Wedding Photographers can make use of the CRM
                module to manage their photo shoot assignments, get the photos
                selected by their clients and get the selected &amp; edited
                event photographs uploaded to FamilyPhotosAlbum.com (FPA). The
                clients of the studio can then avail all the features of FPA,
                including the provision to make their Family Trees.
              </li>
              <li>
                Customers of Photofind/FPA can organise the photos by grouping
                into different sub albums. They can also rearrange the positions
                of the photos in the gallery/albums based on a timeline or
                manual re positioning.
              </li>
              <li>
                The file size of the photos may be optimised by Photofind for
                better performance of the album pages.
              </li>

              <li>
                The photos you upload to Photofind/FPA are kept secured. The
                albums will be purely private unless the user wants to share
                them.
              </li>
              <li>
                Users can delete the photos or albums from their page at will.
                Photofind will not have any right on the photos you upload.
              </li>
              <li>
                For the customers of the Studio for whom accounts are created in
                FPA, a log-in procedure has to be completed to access the Photo
                Album or Family Tree. If they forget the password, there is a
                provision to reset the password. The new password will be
                intimated to the user through their registered E mail.
              </li>
              <li>
                We encourage users to keep their page in an organised and
                presentable form. Towards this, the facility for creation and
                naming of sub albums has been provided. Remove wrongly exposed
                and unwanted photos so that you keep a presentable, good quality
                album which can be proudly displayed to other family members or
                friends.
              </li>
              <li>
                Users can also post Embedded Video Links from YouTube, Vimeo,
                and Instagram on their page. A maximum of 15 video links can be
                posted on your page.
              </li>
              <li>
                <a
                  href="https://familyphotosalbum.com"
                  target="_blank"
                  className="a"
                >
                  FamilyPhotosAlbum.com
                </a>{" "}
                and{" "}
                <a href="https://photofind.in" className="a">
                  Photofind.in
                </a>{" "}
                (FPA’s Studio/Corporate front end) are not mass storage
                solutions. Both these linked portals do not store the photos
                uploaded in its original size.
              </li>
              <li>
                For the studio customers of Photofind, a maximum of 1200
                photographs can be uploaded per account. For corporate accounts,
                a maximum of 3000 photos can be uploaded. These limits can be
                increased later by subscribing to the add-on packages offered
                from time to time.
              </li>
            </ol>

            <h2>Information on Photofind’s ownership</h2>
            <p>
              <a
                href="https://familyphotosalbum.com"
                target="_blank"
                rel="noopener noreferrer"
                className="a"
              >
                FamilyPhotosAlbum.com
              </a>{" "}
              its Studio/Corporate front-end{" "}
              <a href="https://photofind.in" className="a">
                Photofind.in
              </a>{" "}
              are owned by Hamphotos Private Limited, Kochi, India where K G
              Girish Babu is the Managing Director.
            </p>
            <p>
              {" "}
              Operational address: Hamphotos Private Limited – Corporate Office:
              36/339, Govardhanam, MRA Plot 138, Mavelipuram Zone 3, Kakkanad,
              Kochi 682030{" "}
            </p>
            <p>
              The product development, upkeep, and maintenance are under a
              long-term contract with M/s Webandcrafts, a 300+ employee company
              located within a Government-owned IT Park Special Economic Zone in
              Kerala, India.{" "}
            </p>
            <p>
              You may go through Photofind’s Privacy Policy where our aim is to
              comply with GDPR.
            </p>

            <h2>Conclusion</h2>
            <p>
              Photofind is created and offered based on a deep passion for
              Photography and Information Technology.
            </p>
            <p>
              Log in and enjoy{" "}
              <a href="https://photofind.in" className="a">
                Photofind.in
              </a>
            </p>
            <i>
              File: Photofind/I&G Version 1.07 Dated 31 st December 2024
            </i>
          </div>
        </div>
      </div>
    </>
  );
};

export default InformationAndGuidelines;
